import { create } from "zustand"

export interface AISuggestion {
  content: string
  title: string
}

type AIMessageStore = {
  isLoading: boolean
  setIsLoading: (isLoading: boolean) => void
  suggestions: AISuggestion[]
  setSuggestions: (suggestions: AISuggestion[]) => void

  currentSuggestionIndex: number
  setCurrentSuggestionIndex: (currentSuggestionIndex: number) => void

  hasError: boolean
  setHasError: (hasError: boolean) => void

  hasCopiedSuggestion: boolean
  setHasCopiedSuggestion: (hasCopiedSuggestion: boolean) => void
}

const useAIMessageStore = create<AIMessageStore>()((set) => ({
  isLoading: false,
  setIsLoading: (isLoading: boolean) => set({ isLoading }),
  suggestions: [],
  setSuggestions: (suggestions: AISuggestion[]) => set({ suggestions }),

  currentSuggestionIndex: 0,
  setCurrentSuggestionIndex: (currentSuggestionIndex: number) =>
    set({ currentSuggestionIndex }),

  hasError: false,
  setHasError: (hasError: boolean) => set({ hasError }),

  hasCopiedSuggestion: false,
  setHasCopiedSuggestion: (hasCopiedSuggestion: boolean) =>
    set({ hasCopiedSuggestion }),
}))

export default useAIMessageStore
